import React from 'react';

import { ControlsOpacity, CONTROLS_IDLE_TIMEOUT } from '../constants';

export type UseControlsVisibilityReturn = {
  controlsOpacity: number;
  handleUserActivity: () => void;
};

const useControlsVisibility = (): UseControlsVisibilityReturn => {
  const [isIdle, setIsIdle] = React.useState(false);
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = React.useCallback(() => {
    setIsIdle(false);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      setIsIdle(true);
    }, CONTROLS_IDLE_TIMEOUT);
  }, []);

  React.useEffect(() => {
    resetTimer();
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [resetTimer]);

  return {
    controlsOpacity: isIdle ? ControlsOpacity.IDLE : ControlsOpacity.ACTIVE,
    handleUserActivity: resetTimer
  };
};

export default useControlsVisibility;
